<template>
  <div>
    <div data-v-2cd1e300="" data-v-2ac6a5fc="" class="sidebar-container">
      <div data-v-2cd1e300="" class="sidebar pad-b-50 inactive">
        <div data-v-2cd1e300="" class="loginRegist" v-if="!$store.state.token">
          <div data-v-2cd1e300="" class="icon icon-webp"></div>
          <button data-v-2cd1e300="" class="login" @click="$parent.goNav('/login')">登录&nbsp;/&nbsp;注册</button>
        </div>
        <div data-v-2cd1e300="" class="myAccount" v-if="$store.state.token">
          <div data-v-2cd1e300="" class="top">
            <div data-v-2cd1e300="" class="user">
              
              <div data-v-2cd1e300="" class="icon-male icon-webp">
                <img style="width:100%;border-radius: 50%;" src="/static/image/img1.2ceab29b.png" alt="">
              </div>
              <div data-v-2cd1e300="" class="info">
                <span data-v-2cd1e300="">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</span
                ><span data-v-2cd1e300="" class="balance">{{ $store.state.userInfo.balance }}</span>
              </div>
            </div>
            <a @click="$parent.goNav('/userCenter')"
              ><div data-v-2cd1e300="" class="button">
                <span data-v-2cd1e300="" style="font-size: 10px">账户</span>
                <div data-v-2cd1e300="" class="arrow icon-webp"></div></div
            ></a>
          </div>
          <div data-v-2cd1e300="" class="withdraw-deposit">
            <div data-v-2cd1e300="" class="deposit cny">
              <a @click="$parent.goNav('/deposit')">
                <div data-v-2cd1e300="" class="icon icon-webp"></div>
                <span data-v-2cd1e300="" style="color: #cca352">存款</span></a
              >
            </div>
            <div data-v-2cd1e300="" class="withDraw cny">
              <a @click="$parent.goNav('/withdraw')">
                <div data-v-2cd1e300="" class="icon icon-webp"></div>
                <span data-v-2cd1e300="" style="color: #cca352">取款</span></a
              >
            </div>
          </div>
        </div>
        <ul data-v-2cd1e300="" class="menu">
          <li data-v-2cd1e300="" class="">
            <a @click="$parent.goNav('/')">
              <div data-v-2cd1e300="" :class="path == '/' ? 'menu-item active' : 'menu-item inactive'">
                <div data-v-2cd1e300="" class="icon-webp home"></div>
                <span data-v-2cd1e300="" class="m-link">首页</span>
              </div>
            </a>
          </li>

          <li data-v-2cd1e300="" class="">
            <a @click="$parent.goNav('/activeList')">
              <div data-v-2cd1e300="" :class="path == '/activeList' ? 'menu-item active' : 'menu-item inactive'">
                <div data-v-2cd1e300="" class="icon-webp promotions"></div>
                <span data-v-2cd1e300="" class="m-link">优惠活动</span>
                <div data-v-2cd1e300=""></div>
              </div>
            </a>
          </li>
          <li data-v-2cd1e300="" class="" style="display: none;">
            <a @click="$parent.goNav('/sponsor')">
              <div data-v-2cd1e300="" :class="path == '/sponsor' ? 'menu-item active' : 'menu-item inactive'">
                <div data-v-2cd1e300="" class="icon-webp mien"></div>
                <span data-v-2cd1e300="" class="m-link">{{$store.state.appInfo.title}}风采</span>
              </div>
            </a>
          </li>
          <li data-v-2cd1e300="" class="">
            <a @click="getAgentLoginUrl">
              <div data-v-2cd1e300="" class="menu-item inactive">
                <div data-v-2cd1e300="" class="icon-webp partner"></div>
                <span data-v-2cd1e300="" class="m-link">超级合伙人</span>
              </div>
            </a>
          </li>
          <li data-v-2cd1e300="" class="">
            <a @click="$parent.goNav('/app')">
              <div data-v-2cd1e300="" :class="path == '/app' ? 'menu-item active' : 'menu-item inactive'">
                <div data-v-2cd1e300="" class="icon-webp download"></div>
                <span data-v-2cd1e300="" class="m-link">APP / 游戏下载</span>
              </div>
            </a>
          </li>
          <li data-v-2cd1e300="" class="">
            <a @click="$parent.goNav('/vip')">
              <div data-v-2cd1e300="" :class="path == '/vip' ? 'menu-item active' : 'menu-item inactive'">
                <div data-v-2cd1e300="" class="icon-webp vip"></div>
                <span data-v-2cd1e300="" class="m-link">VIP专区</span>
              </div>
            </a>
          </li>
        </ul>
        <div data-v-2cd1e300="" class="service">
          <button data-v-2cd1e300="" @click="$parent.openKefu()" style="max-width: 148px">在线客服</button>
        </div>
        <p data-v-2cd1e300="" class="usdt-tips">支持数字币存取 <span data-v-2cd1e300="" class="c-yellow">安全·便捷·秒到账</span></p>
      </div>
      <div data-v-2cd1e300="" class="cover inactive"></div>
    </div>
    <div data-v-2d8c5019="" v-if="!$store.state.token" data-v-e928e504="" class="login-bar top_login_bar webp" 
    style="display: none;padding-bottom: constant(safe-area-inset-bottom); padding-bottom: env(safe-area-inset-bottom)">
      <div data-v-2d8c5019="" class="bar-group">
        <button data-v-2d8c5019="" class="button left-button left" @click="$parent.goNav('/login')">立即登录</button>
        <button data-v-2d8c5019="" class="button right-button left" @click="$parent.goNav('/register')"><img data-v-2d8c5019="" src="/static/image/gift3.png.252e43f4.webp" alt="" class="icon-new-gift" /> 免费开户</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Left',
  data() {
    return { path: '' };
  },
  methods: {
    getAgentLoginUrl() {
      let that = this;
      that.$parent.goNav(`/gamePage?dailiD=1`);
    },
  },
  mounted() {},
  watch: {
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/libs/Left.vue